import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { CreateActionCommentGQL, CreateActionCommentMutation, CreateActionCommentMutationVariables, CreateActionGQL, CreateActionMutation, CreateActionMutationVariables, GetActionByIdGQL, GetActionByIdQuery, GetActionByIdQueryVariables, UpdateActionGQL, UpdateActionMutation, UpdateActionMutationVariables, UpdateActionStatusGQL, UpdateActionStatusMutation, UpdateActionStatusMutationVariables } from "src/generated/graphql";
import {
  DeleteActionGQL,
  DeleteActionMutation,
  GetAllActionsGQL,
  GetAllActionsQuery,
  UpdateAllActionsGQL,
  UpdateAllActionsMutation,
  UpdateAllActionsMutationVariables,
} from "src/generated/graphql/idea/action/action.graphql";

@Injectable({
  providedIn: "root",
})
export class ActionService {
  constructor(
    private getAllActionsGQL: GetAllActionsGQL,
    private deleteActionGQL: DeleteActionGQL,
    private createActionGQL: CreateActionGQL,
    private updateActionGQL: UpdateActionGQL,
    private updateActionStatusGQL: UpdateActionStatusGQL,
    private createActionCommentGQL: CreateActionCommentGQL,
    private updateAllActionsGQL: UpdateAllActionsGQL,
    private getActionByIdGQL: GetActionByIdGQL,
  ) {}

  createAction({ input }: CreateActionMutationVariables): Observable<CreateActionMutation> {
    return this.createActionGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to create actions"));
      })
    )
  }

  getActionById({ id }: GetActionByIdQueryVariables): Observable<GetActionByIdQuery> {
    return this.getActionByIdGQL.fetch({ id }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to get action"));
      })
    )
  }

  createActionComment({ input }: CreateActionCommentMutationVariables): Observable<CreateActionCommentMutation> {
    return this.createActionCommentGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to create action comment"));
      })
    )
  }

  updateAction({ input }: UpdateActionMutationVariables): Observable<UpdateActionMutation> {
    return this.updateActionGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to update actions"));
      })
    )
  }

  updateAllActions({ input }: UpdateAllActionsMutationVariables): Observable<UpdateAllActionsMutation> {
    return this.updateAllActionsGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to update all actions"));
      })
    )
  }

  updateActionStatus({ id, status }: UpdateActionStatusMutationVariables): Observable<UpdateActionStatusMutation> {
    return this.updateActionStatusGQL.mutate({ id, status }).pipe(
      map((result) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to update actions status"));
      })
    )
  }

  getAllActions(id: string): Observable<GetAllActionsQuery> {
    return this.getAllActionsGQL.watch({ id }).valueChanges.pipe(
      map((result) => {
        return result.data;
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to fetch actions"));
      })
    );
  }

  deleteAction(id: string, ideaId?: string): Observable<DeleteActionMutation> {
    return this.deleteActionGQL.mutate({ id, ideaId }).pipe(
      map((result: { data: DeleteActionMutation }) => {
        return result.data;
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to fetch actions"));
      })
    );
  }
}
